import { Link } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";
import { buildWhatsAppLink, telHref, BUSINESS_PHONE_DISPLAY } from "../../lib/whatsapp";
import { WhatsAppIcon, Mark } from "./Icons";
import { Phone, Mail, MapPin } from "lucide-react";

const NAV_COLS = [
  { title: "Explore", links: [
    { to: "/", label: "Home" },
    { to: "/hyderabad-to-srisailam", label: "Hyderabad to Srisailam" },
    { to: "/srisailam-tour-packages", label: "Tour Packages" },
  ] },
  { title: "Services", links: [
    { to: "/srisailam-cab-service", label: "Cab Services" },
    { to: "/srisailam-sightseeing", label: "Srisailam Sightseeing" },
    { to: "/contact", label: "Contact" },
  ] },
];

export default function Footer() {
  const { settings } = useSettings();
  const wa = buildWhatsAppLink();
  const phone = BUSINESS_PHONE_DISPLAY;
  return (
    <footer className="bg-navy-deep text-white pb-16 md:pb-0" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <Mark className="h-14 w-auto rounded-md bg-white p-1.5" />
            <div>
              <p className="font-heading text-2xl leading-none">RSK Tours</p>
              <p className="text-white/60 text-sm mt-1">Hyderabad to Srisailam Tours & Cab Services</p>
            </div>
          </div>
          <p className="text-white/60 leading-relaxed max-w-md">Trusted temple tours, sightseeing packages and reliable cabs from Hyderabad to Srisailam — planned by Sudheer Kumar for families, couples and groups.</p>
          <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-btn"
            className="mt-6 inline-flex items-center gap-2 bg-gold hover:bg-gold-hover text-navy-deep px-6 py-3 rounded-full transition-colors font-medium">
            <WhatsAppIcon className="w-5 h-5" /> Book on WhatsApp
          </a>
        </div>

        {NAV_COLS.map((col) => (
          <div key={col.title}>
            <p className="text-xs uppercase tracking-[0.2em] text-gold mb-5">{col.title}</p>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.to}><Link to={l.to} className="text-white/70 hover:text-white transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-8 grid md:grid-cols-2 gap-6 text-white/70">
          <div className="space-y-2 text-sm">
            {settings?.contact_name && <p className="text-white font-medium">{settings.contact_name}</p>}
            {phone && <p className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> <a href={telHref} className="hover:text-white">{BUSINESS_PHONE_DISPLAY}</a></p>}
            {settings?.email && <p className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> <a href={`mailto:${settings.email}`} className="hover:text-white">{settings.email}</a></p>}
            {settings?.address && <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> {settings.address}</p>}
          </div>
          <div className="text-sm text-white/40 md:text-right space-y-1">
            <p>© {new Date().getFullYear()} RSK Tours. All rights reserved.</p>
            <p><Link to="/admin/login" className="hover:text-white/70" data-testid="footer-admin-link">Admin</Link></p>
          </div>
        </div>
      </div>
    </footer>
  );
}
